<div class="role-edit-page">

  @if (isLoading) {
    <div class="loading-state">
      <span class="loading-spinner"></span>
      <span>Loading role…</span>
    </div>
  }

  @if (!isLoading && role) {

    <!-- ── Page header ───────────────────────────── -->
    <app-page-header
      [section]="headerBreadcrumbSection"
      pageTitle="Edit role"
      [badgeText]="displayCode"
      [subtitle]="role.usersCount + ' linked user' + (role.usersCount !== 1 ? 's' : '')"
      [actions]="pageHeaderActions">
    </app-page-header>

    <!-- ── Two-column layout ─────────────────────── -->
    <div class="two-col">

      <!-- Left: form -->
      <div class="col-form">

        <app-edit-mode-banner
          [variant]="bannerVariant"
          [message]="bannerMessage"
          [subMessage]="bannerSubMessage">
        </app-edit-mode-banner>

        <form [formGroup]="form" novalidate>

          <!-- Section 01: Identity -->
          <div class="form-card">
            <div class="section-header">
              <div class="section-header__left">
                <span class="section-num">01</span>
                <span class="section-title">Identity</span>
              </div>
              <span class="section-meta">Name &amp; description</span>
            </div>
            <div class="section-body">

              <div class="field-group">
                <div class="field-label-row">
                  <label class="field-label">Role name <span class="required-dot">●</span></label>
                  <span class="field-badge">must be unique</span>
                </div>
                <div class="name-input-wrap">
                  <input type="text" class="field-input"
                    [class.field-input--error]="nameValidationState.status === 'conflict' || nameValidationState.status === 'error'"
                    [class.field-input--valid]="nameValidationState.status === 'valid'"
                    formControlName="name" placeholder="e.g. Region Coordinator" />
                  @if (nameValidationState.status === 'checking') {
                    <span class="name-status-icon"><span class="name-spinner"></span></span>
                  }
                  @if (nameValidationState.status === 'valid') {
                    <span class="name-status-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#3DA66E" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                      </svg>
                    </span>
                  }
                  @if (nameValidationState.status === 'conflict') {
                    <span class="name-status-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#DD6B20" viewBox="0 0 16 16">
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
                      </svg>
                    </span>
                  }
                </div>
                @if (nameValidationState.status === 'conflict') {
                  <span class="field-conflict-msg">{{ nameValidationState.message }}</span>
                }
                @if (nameValidationState.status === 'valid') {
                  <span class="field-valid-msg">✓ Available</span>
                }
              </div>

              <div class="field-group">
                <div class="field-label-row">
                  <label class="field-label">Description</label>
                  <span class="field-badge">optional</span>
                </div>
                <textarea class="field-textarea" formControlName="description" rows="2"
                  placeholder="Briefly describe what this role does…"></textarea>
              </div>

              <div class="field-group field-group--last">
                <div class="field-label-row">
                  <label class="field-label">Status</label>
                </div>
                <label class="toggle-row">
                  <input type="checkbox" formControlName="active" class="toggle-input" />
                  <span class="toggle-track"><span class="toggle-thumb"></span></span>
                  <span class="toggle-label">{{ form.get('active')?.value ? 'Active' : 'Inactive' }}</span>
                </label>
              </div>

            </div>
          </div>

          <!-- Section 02: Permissions -->
          <div class="form-card">
            <div class="section-header">
              <div class="section-header__left">
                <span class="section-num">02</span>
                <span class="section-title">Permissions</span>
              </div>
              <span class="section-meta">{{ grantedCount }} of {{ totalPermissionsCount }} granted</span>
            </div>
            <div class="section-body">
              <app-permission-selector
                [initialPermissions]="initialPermissionsMap"
                (modulesChange)="onModulesChange($event)"
                (totalPermissionsCount)="onPermissionCountChange($event)"
                (moduleCountsChange)="onModuleCountsChange($event)"
                (permissionDiff)="onPermissionDiff($event)">
              </app-permission-selector>
            </div>
          </div>

        </form>
      </div>

      <!-- Right: sidebar -->
      <div class="col-sidebar">
        <app-role-sidebar
          [mode]="sidebarMode"
          [role]="role"
          [diff]="diff"
          [impact]="impact"
          [auditEntries]="auditEntries"
          [moduleCountsMap]="moduleCountsMap">
        </app-role-sidebar>
      </div>

    </div>

  }

</div>
